import { render, staticRenderFns } from "./DeductionContract.vue?vue&type=template&id=b7a8be58&scoped=true&"
import script from "./DeductionContract.vue?vue&type=script&lang=js&"
export * from "./DeductionContract.vue?vue&type=script&lang=js&"
import style0 from "./DeductionContract.vue?vue&type=style&index=0&id=b7a8be58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a8be58",
  null
  
)

export default component.exports